import React, { useEffect, useRef, useState } from 'react';
// import styled from 'styled-components';
import axios from 'axios';
import Select from 'react-select';
import { Switch } from '@mui/material'; // Import from Material-UI
import { FaTrash } from "react-icons/fa";
import "./AddItem.css";
import { useNavigate } from 'react-router-dom';
import { message } from 'antd';
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import APIURL from '../api/apiClient';

const AddItem = () => {
  const [formData, setFormData] = useState({
    name: '',
    brand: '',
    thumbnail: '',
    thumbnailPreview: '',
    images: [],
    imagePreviews: [],
    description: '',
    category: '',
    category_id: [],
    actual_price: '',
    selling_price: '',
    tax_percentage: '',
    discount: '',
    status: '',
    stock: '',
    moq: '',
    approved: '',
    refurbished: '',
    net_weight: '',
    dimensions: '',
  });
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');
  // const fileInputRef = useRef(null);
  const fileInputRef = React.useRef(null);
  const navigate = useNavigate();


  const [errors, setErrors] = useState({});

  const validate = () => {
    const newErrors = {};
    if (!formData.name) newErrors.name = "Name is required";
    if (!formData.brand) newErrors.brand = "Brand is required";
    // if (formData.thumbnail.length === 0) newErrors.thumbnail = "At least one image is required"; // For thumbnail image
    if (formData.images.length > 5) newErrors.images = "You can only upload 5 images"; // For normal multiple images
    if (!formData.category_id) newErrors.category_id = "Please select a category";
    if (!formData.actual_price || isNaN(formData.actual_price) || formData.actual_price <= 0)
      newErrors.actual_price = "Actual price must be a positive number";
    if (!formData.selling_price || isNaN(formData.selling_price) || formData.selling_price <= 0)
      newErrors.selling_price = "Selling price must be a positive number";
    if (!formData.tax_percentage || isNaN(formData.tax_percentage))
      newErrors.tax_percentage = "Please enter a valid tax percentage";
    if (!formData.discount || isNaN(formData.discount))
      newErrors.discount = "Please enter a valid discount";
    // if (formData.status === 0) newErrors.status = "Status must be on";
    // if (formData.stock && isNaN(formData.stock))
    //   newErrors.stock = "Stock must be a valid number";
    // if (formData.moq && isNaN(formData.moq))
    //   newErrors.moq = "MOQ must be a valid number";
    // if (!formData.approved) newErrors.approved = "Please select an option for Approved";
    // if (!formData.refurbished) newErrors.refurbished = "Please select an option for Refurbished";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const calculateDiscount = (actual, selling) => {
    if (!actual || actual <= 0 || !selling) return '';
    const discount = ((actual - selling) / actual) * 100;
    return discount.toFixed(2);
  };

  const calculateSellingPrice = (actual, discount) => {
    if (!actual || actual <= 0 || !discount) return '';
    const selling = actual - (actual * (discount / 100));
    return selling.toFixed(2);
  };

  const handleChange = (e) => {
    const { name, type, checked, files, value } = e.target;

    if (type === 'checkbox') {
      setFormData((prevData) => ({
        ...prevData,
        [name]: checked ? 1 : 0,
      }));
    }

    else if (type === 'file') {
      if (name === 'thumbnail') {
        const thumbnailFile = files[0];
        const thumbnailPreview = URL.createObjectURL(thumbnailFile);

        setFormData((prevData) => ({
          ...prevData,
          thumbnail: thumbnailFile,
          thumbnailPreview,
        }));
      }
      else if (name === 'images') {
        const selectedFiles = Array.from(files);
        const newImagePreviews = selectedFiles.map((file) => URL.createObjectURL(file));

        setFormData((prevData) => ({
          ...prevData,
          images: [...prevData.images, ...selectedFiles].slice(0, 5),
          imagePreviews: [...(prevData.imagePreviews || []), ...newImagePreviews].slice(0, 5),
        }));

        if (fileInputRef.current) {
          fileInputRef.current.value = '';
        }
      }
    }
    else {
      setFormData((prev) => {
        let updatedValues = { ...prev, [name]: value };

        // Discount calculation logic
        if (name === "actual_price" || name === "selling_price") {
          const actual = parseFloat(updatedValues.actual_price);
          const selling = parseFloat(updatedValues.selling_price);
          updatedValues.discount = Math.round(calculateDiscount(actual, selling)); // Round instantly
        }

        if (name === "discount") {
          const n = parseFloat(updatedValues.discount);
          updatedValues.discount = Number.isFinite(n) ? Math.round(n) : '';
        }

        if (name === "actual_price" || name === "discount") {
          const actual = parseFloat(updatedValues.actual_price);
          const discount = parseFloat(updatedValues.discount);
          updatedValues.selling_price = calculateSellingPrice(actual, discount);
        }

        return updatedValues;
      });
    }
  };

  const handleDeleteImage = (indexToDelete) => {
    setFormData((prevData) => ({
      ...prevData,
      images: prevData.images.filter((_, index) => index !== indexToDelete),
      imagePreviews: prevData.imagePreviews.filter((_, index) => index !== indexToDelete),
    }));
  };


  useEffect(() => {
    const fetchData = async () => {
      try {
        const newDataRaw = await APIURL.get("/fetchcategories.php");

        // Make sure it's an array
        const newData = Array.isArray(newDataRaw) ? newDataRaw : JSON.parse(newDataRaw);

        const formattedCategories = newData.map((category) => ({
          value: category.id,
          label: category.name,
        }));

        setCategories(formattedCategories);
      } catch (error) {
        console.error('Error fetching categories:', error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (!selectedCategory) {
      setSubCategories([]);
      setSelectedSubCategory(null);
      return;
    }

    const fetchSubCategories = async () => {
      try {
        const res = await APIURL.get(`/subCategories.php?category_id=${selectedCategory.value}`);

        // API returns { status: true, data: [...] }
        if (res.status && Array.isArray(res.data)) {
          const formattedSubCats = res.data.map(sub => ({
            value: sub.id,
            label: sub.name
          }));

          setSubCategories(formattedSubCats.length > 0 ? formattedSubCats : []);
          setSelectedSubCategory(null);
        } else {
          setSubCategories([]);
          setSelectedSubCategory(null);
        }
      } catch (err) {
        console.error("Error fetching subcategories:", err);
        setSubCategories([]);
        setSelectedSubCategory(null);
      }
    };

    fetchSubCategories();
  }, [selectedCategory]);



  // Main category change
  const handleMainCategoryChange = (option) => {
    console.log(option);
    setSelectedCategory(option); // MUST set selectedCategory so useEffect triggers
    setSelectedSubCategory(null); // reset subcategory
    setFormData(prev => ({
      ...prev,
      category_ids: [], // reset subcategory ids
    }));
  };

  // Subcategory change
  const handleSubCategoryChange = (option) => {
    setSelectedSubCategory(option);
    setFormData(prev => ({
      ...prev,
      category_ids: option ? [option.value] : [],
    }));
  };


  const handleDescriptionChange = (content) => {
    setFormData(prev => ({
      ...prev,
      description: content,
    }));
  };


  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   if (!validate()) return;

  //   try {
  //     const formDataObj = new FormData();

  //     // Append other form fields
  //     Object.keys(formData).forEach((key) => {
  //       if (key === "images" && formData.images.length) {
  //         formData.images.forEach((image) => {
  //           if (image instanceof File) formDataObj.append("images[]", image);
  //         });
  //       } else if (key === "thumbnail") {
  //         if (formData.thumbnail instanceof File) formDataObj.append("thumbnail", formData.thumbnail);
  //       } else if (key !== "category" && key !== "category_id") {
  //         // skip category fields here; we'll append correct ones below
  //         formDataObj.append(key, formData[key]);
  //       }
  //     });

  //     // Append category IDs correctly
  //     if (selectedCategory) formDataObj.append("category", selectedCategory.value); // main category ID

  //     if (selectedSubCategory) {
  //       // MUST send as array
  //       formDataObj.append("category_id", JSON.stringify([selectedSubCategory.value]));
  //     }

  //     // Debug
  //     for (let pair of formDataObj.entries()) {
  //       console.log(`${pair[0]}: ${pair[1]}`);
  //     }

  //     let response = await APIURL.post("/insertitems.php", formDataObj, true);

  //     console.log("Server response:", response);

  //     // If response is a string (not JSON), try to parse it
  //     if (typeof response === "string") {
  //       try {
  //         response = JSON.parse(response.trim());
  //       } catch {
  //         // fallback if not JSON
  //         response = { success: false, message: response };
  //       }
  //     }
  //     if (response.status) {
  //       message.success("Item Added Successfully");
  //       navigate("/items");

  //       // Reset form
  //       setFormData({
  //         name: "",
  //         brand: "",
  //         thumbnail: "",
  //         images: [],
  //         description: "",
  //         category: "",
  //         category_id: [],
  //         actual_price: "",
  //         selling_price: "",
  //         tax_percentage: "",
  //         discount: "",
  //         status: "",
  //         stock: "",
  //         moq: "",
  //         approved: "",
  //         refurbished: "",
  //       });
  //       setSelectedCategory(null);
  //       setSelectedSubCategory(null);
  //       setSubCategories([]);
  //       setErrorMessage("");
  //     }
  //   } catch (error) {
  //     console.error("Error submitting form:", error);
  //     setErrorMessage("Submission failed. Please try again.");
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    try {
      const formDataObj = new FormData();

      // 1️⃣ Append all regular fields except category fields
      Object.keys(formData).forEach((key) => {
        if (key === "images" && formData.images.length) {
          formData.images.forEach((image) => {
            if (image instanceof File) formDataObj.append("images[]", image);
          });
        } else if (key === "thumbnail") {
          if (formData.thumbnail instanceof File) formDataObj.append("thumbnail", formData.thumbnail);
        } else if (key !== "category" && key !== "category_id") {
          formDataObj.append(key, formData[key]);
        }
      });

      // 2️⃣ Append main category ID
      if (selectedCategory) {
        formDataObj.append("category", selectedCategory.value);
      }

      // 3️⃣ Append subcategory IDs as array
      if (selectedSubCategory) {
        formDataObj.append("category_id", JSON.stringify([selectedSubCategory.value]));
      }

      // // 4️⃣ Debug: log FormData contents
      // for (let pair of formDataObj.entries()) {
      //   console.log(`${pair[0]}:`, pair[1]);
      // }

      // 5️⃣ Send to API
      let response = await APIURL.post("/insertitems.php", formDataObj, true);
      // console.log(response);

      // 6️⃣ Ensure JSON response
      if (typeof response === "string") {
        try {
          response = JSON.parse(response.trim());
        } catch {
          response = { success: false, message: response };
        }
      }

      // 7️⃣ Handle success
      if (response.success) {
        message.success("Item Added Successfully");
        navigate("/items");

        // 8️⃣ Reset form
        setFormData({
          name: "",
          brand: "",
          thumbnail: "",
          images: [],
          description: "",
          category: "",
          category_id: [],
          actual_price: "",
          selling_price: "",
          tax_percentage: "",
          discount: "",
          status: "",
          stock: "",
          moq: "",
          approved: "",
          refurbished: "",
          net_weight: '',
          dimensions: '',
        });
        setSelectedCategory(null);
        setSelectedSubCategory(null);
        setSubCategories([]);
        setErrorMessage("");
      } else {
        setErrorMessage(response.message || "Submission failed");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setErrorMessage("Submission failed. Please try again.");
    }
  };



  return (
    <div className="form-container">
      <h2 className="form-title">Add Item</h2>
      <form onSubmit={handleSubmit} formEncType='multipart/form-data' className='form-group'>
        <div className="form-grid">
          {/* Left Column - Form Fields */}
          <div className="form-fields">
            <div className='name-brand'>
              <label htmlFor="name" className="label">Name</label>
              <input
                type="text"
                id="name"
                name="name"
                placeholder="Enter name"
                className="form-control input"
                value={formData.name}
                onChange={handleChange}
                required
              />
              {errors.name && <div className="error-message">{errors.name}</div>}

              <label htmlFor="brand" className="label">Brand</label>
              <input
                type="text"
                id="brand"
                name="brand"
                placeholder="Enter your brand"
                className="form-control input"
                value={formData.brand}
                onChange={handleChange}
                required
              />
              {errors.brand && <div className="error-message">{errors.brand}</div>}
            </div>

            <label htmlFor="description" className="label">Description</label>
            <ReactQuill
              theme="snow"
              value={formData.description}
              onChange={handleDescriptionChange}
              placeholder="Enter description"
              style={{ marginBottom: "50px" }}
            />

            <label htmlFor="category" className="label">Main Category</label>
            <Select
              name="category"
              className="custom-select select"
              placeholder="Select Main Category"
              onChange={handleMainCategoryChange}
              options={categories || []}
              value={selectedCategory}
              required
            />

            <label htmlFor="subcategory_id" className="label">Sub Category</label>
            <Select
              required
              name="category_id"
              className="custom-select select"
              options={
                selectedCategory
                  ? subCategories.length > 0
                    ? subCategories
                    : [{ value: "", label: "No subcategories available", isDisabled: true }]
                  : []
              }
              onChange={handleSubCategoryChange}
              value={selectedSubCategory}
              placeholder={selectedCategory ? "Select Subcategory" : "Select Main Category first"}
              isDisabled={!selectedCategory} // only disable if no main category selected
            />


            <label htmlFor="actual_price" className="label">Actual Price</label>
            <input
              type="number"
              id="actual_price"
              name="actual_price"
              placeholder="Enter actual price"
              className="form-control input"
              value={formData.actual_price}
              onChange={handleChange}
              required
            />
            {errors.actual_price && <div className="error-message">{errors.actual_price}</div>}

            <label htmlFor="selling_price" className="label">Selling Price</label>
            <input
              type="number"
              id="selling_price"
              name="selling_price"
              placeholder="Enter selling price"
              className="form-control input"
              value={formData.selling_price}
              onChange={handleChange}
              required
            />
            {errors.selling_price && <div className="error-message">{errors.selling_price}</div>}

            <label htmlFor="tax_percentage" className="label">Tax Percentage (%)</label>
            <input
              type="number"
              id="tax_percentage"
              name="tax_percentage"
              placeholder="Enter tax percentage"
              className="form-control input"
              value={formData.tax_percentage}
              onChange={handleChange}
              required
            />
            {errors.tax_percentage && <div className="error-message">{errors.tax_percentage}</div>}

            <div className="switch-container">
              <span className="switch-label">Status</span>
              <Switch
                checked={formData.status}
                onChange={(e) => handleChange({ target: { name: 'status', type: 'checkbox', checked: e.target.checked } })}
                name="status"
              />
            </div>

            <label htmlFor="discount" className="label">Discount (%)</label>
            <input
              type="number"
              id="discount"
              name="discount"
              placeholder="Enter discount"
              className="form-control input"
              value={formData.discount}
              onChange={handleChange}
              required
            />
            {errors.discount && <div className="error-message">{errors.discount}</div>}
          </div>

          {/* Right Column - Images and Additional Fields */}
          <div className="form-sidebar">
            {/* Image Upload Card */}
            <div className='image-upload-card'>
              <h3 className="section-title">Images</h3>

              <div className='thumbnail-upload'>
                <label htmlFor="thumbnail" className="label-thumbnail">
                  Add <br />Thumbnail
                  <input
                    type="file"
                    id="thumbnail"
                    name="thumbnail"
                    accept="image/png, image/jpg, image/jpeg, image/webp"
                    onChange={handleChange}
                  />
                </label>
                {formData.thumbnail && (
                  <div className='thumbnail-preview'>
                    <img
                      src={formData.thumbnailPreview}
                      alt='thumbnail-preview'
                      className='thumbnail-img'
                    />
                  </div>
                )}
              </div>

              <div className='additional-images'>
                <div className="images-upload-container">
                  <label className="images-label" htmlFor="images">
                    + Add Images <br /> <span>Up to 5 images</span>
                    <input
                      type="file"
                      name="images"
                      accept="image/*"
                      id='images'
                      multiple
                      onChange={handleChange}
                      ref={fileInputRef}
                    />
                  </label>

                  <div className="images-preview">
                    {Array.isArray(formData.imagePreviews) &&
                      formData.imagePreviews.map((image, index) => (
                        <div key={index} className="image-preview-item">
                          <img src={image} alt="preview" className="preview-img" />
                          <button onClick={() => handleDeleteImage(index)} className="delete-button">
                            <FaTrash className="trash-icon" />
                          </button>
                          <span className="image-number">{index + 1}</span>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>

            {/* Additional Fields Card */}
            <div className='additional-fields-card'>
              <h3 className="section-title">Additional Details</h3>

              <label htmlFor="stock" className="label">Stock</label>
              <input
                type="number"
                id="stock"
                name="stock"
                placeholder="Enter stock"
                className="form-control input"
                value={formData.stock}
                onChange={handleChange}
              />
              {errors.stock && <div className="error-message">{errors.stock}</div>}

              <label htmlFor="moq" className="label">Maximum Order Quantity</label>
              <input
                type="number"
                id="moq"
                name="moq"
                placeholder="Enter MOQ"
                className="form-control input"
                value={formData.moq}
                onChange={handleChange}
              />
              {errors.moq && <div className="error-message">{errors.moq}</div>}

              <label htmlFor="approved" className="label">Approved</label>
              <select
                id="approved"
                name="approved"
                className="custom-select select"
                value={formData.approved}
                onChange={handleChange}
              >
                <option value="" disabled>Select Option</option>
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
              {errors.approved && <div className="error-message">{errors.approved}</div>}

              <label htmlFor="refurbished" className="label">Refurbished</label>
              <select
                id="refurbished"
                name="refurbished"
                className="custom-select select"
                value={formData.refurbished}
                onChange={handleChange}
              >
                <option value="" disabled>Select Option</option>
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
              {errors.refurbished && <div className="error-message">{errors.refurbished}</div>}

              <label htmlFor="net_weight" className="label">Net Weight</label>
              <input
                type="text"
                id="net_weight"
                name="net_weight"
                placeholder="Enter Net Weight"
                className="form-control input"
                value={formData.net_weight}
                onChange={handleChange}
              />

              <label htmlFor="dimensions" className="label">Dimensions </label>
              <input
                type="text"
                id="dimensions"
                name="dimensions"
                placeholder="Enter Dimensions"
                className="form-control input"
                value={formData.dimensions}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>

        <button type="submit" name='submit' className="btn btn-primary submit-button">
          Submit
        </button>
      </form>
    </div>
  );


};

export default AddItem;


